<p-panel header="{{'pages_titles.plug_and_charge' | translate}}">
    <div class="text-center mt-5 mb-5">
        <p class="p-text">
            {{'comingSoon' | translate}}
        </p>
    </div>
</p-panel>